<template>
    <div class="wrapper">
        <h1 class="crumb">安装单报表</h1>
        <div class="bar">
            <div class="btnGroup">
                <el-button class="btn" @click="Report">安装单导出</el-button>
                <span style="margin-left: 20px;">安装日期　</span>
                <el-date-picker
                    v-model="installDate"
                    type="daterange"
                    range-separator="至"
                    @change="getInstallList"
                    start-placeholder="开始日期"
                    end-placeholder="结束日期">
                </el-date-picker>
                <span style="margin-left: 20px;">订单来源　</span>
                <el-select v-model="ddly" placeholder="请选择" style="width: 150px;" @change="getInstallList">
                    <el-option
                        v-for="item in ddlySelect"
                        :key="item.referer"
                        :label="item.name"
                        :value="item.referer">
                    </el-option>
                </el-select>
                <!--<el-button class="btn" @click="searchOrder" style="margin-left: 20px">搜索</el-button>-->
                <el-select v-model="ssgn" placeholder="请选择" style="width: 150px;margin-left: 100px" @change="selectCompanys">
                    <el-option
                        v-for="item in ssgnSelect"
                        :key="item.referer"
                        :label="item.name"
                        :value="item.referer">
                    </el-option>
                </el-select>
                <span><el-input v-model="searchKey" style="width: 200px" placeholder="请输入" v-show="isCompany === false"></el-input></span>
                <span v-show="isCompany === true">
                    <el-select v-model="searchKey" placeholder="公司名称" >
                            <el-option v-for="item in selectCompany" :label="item.company_name" :value="item.company_name" :key="item.name"></el-option>
                        </el-select>
                </span>
                <el-button class="btn" @click="getInstallList" style="">搜索</el-button>
            </div>
        </div>
        <el-table
            :data="tableData"
            v-loading="loading"
            style="width: 100%">
            <el-table-column type="index" align="center" width="40"></el-table-column>
            <el-table-column label="销售单位" prop="store_name" align="center" width="135"></el-table-column>
            <el-table-column label="销售订单号" width="100" align="center">
                <template slot-scope="props">
                    <div  style="font-size: 10px;" :style="props.row.referer ==='管理员添加'?{color:'red'}:''">{{props.row.referer !=='管理员添加'?props.row.order_sn:'只安装'}}</div>
                </template>
            </el-table-column>
            <el-table-column label="合同订单号" prop="contract_number" width="100" align="center"></el-table-column>
            <el-table-column label="销售合同号" prop="contract_number" align="center"></el-table-column>
            <el-table-column label="型号" width="120" align="center">
                <template slot-scope="props">
                    <div v-for="item in props.row.order_goods" style="font-size: 10px">{{item.goods_attr_select.length ===0?item.goods_attr:item.goods_attr_select[0]}}</div>
                </template>
            </el-table-column>
            <el-table-column label="数量" width="50" align="center">
                <template slot-scope="props">
                    <div v-for="item in props.row.order_goods">{{item.goods_number}}</div>
                </template>
            </el-table-column>
            <el-table-column label="提单号" prop="tidan" align="center" ></el-table-column>
            <el-table-column label="安装码" prop="install_code" align="center" ></el-table-column>
            <el-table-column label="派工员" prop="company_name" align="center" ></el-table-column>
            <el-table-column label="用户姓名" prop="consignee" align="center" ></el-table-column>
            <el-table-column label="地址"  align="center" width="250">
                <template slot-scope="props">
                    {{props.row.address_all}}
                </template>
            </el-table-column>
            <el-table-column label="电话" prop="mobile" align="center"></el-table-column>
            <el-table-column label="安装情况" prop="status_name" align="center"></el-table-column>
            <el-table-column align="center" label="安装费用" width="120" >
                <template slot-scope="props">
                    <div @click="Details(props.row,+props.row.fee_gaokong+ +props.row.fee_nandu+ +props.row.fee_yuancheng+ +props.row.fee_chaizhuang+ +props.row.fee_gangguan+ +props.row.fee_zhijia)" style="cursor: pointer;color: orangered;">￥{{+props.row.fee_gaokong+ +props.row.fee_nandu+ +props.row.fee_yuancheng+ +props.row.fee_chaizhuang+ +props.row.fee_gangguan+ +props.row.fee_zhijia}}</div>
                </template>
            </el-table-column>
            <el-table-column label="备注" prop="comment" align="center"></el-table-column>
            <el-table-column label="业务员" prop="user_name" align="center" width="80"></el-table-column>
            <el-table-column label="预约时间" prop="yuyue_time" align="center" sortable></el-table-column>
            <el-table-column label="完工日期" prop="finish_time" align="center" sortable></el-table-column>
        </el-table>
        <el-pagination
            @current-change="handleCurrentChange"
            :current-page.sync="currentPage1"
            :page-size="10"
            layout=" total,prev, pager, next"
            :total="total">
        </el-pagination>
        <el-dialog title="费用详情" :visible.sync="FeiyongDetail" width="400px">
            <div v-show="form.fee_other=='0'||typeof form.fee_other!=='object'">{{tests}}</div>
            <el-form :model="form" style="text-align: left;margin-top: 20px;" class="c-table">
                <el-form-item :label="item.name?item.name+':':''" :label-width="formLabelWidth" v-for="item in form.fee_other" :key="item.name" v-show="typeof form.fee_other==='object'">
                    <div>{{item.price}}</div>
                </el-form-item>
                <el-form-item label="支架费:" :label-width="formLabelWidth" v-show="form.fee_zhijia!=='0.00'">
                    <div>{{form.fee_zhijia}}</div>
                </el-form-item>
                <el-form-item label="高空费:" :label-width="formLabelWidth" v-show="form.fee_gaokong!=='0.00'">
                    <div>{{form.fee_gaokong}}</div>
                </el-form-item>
                <el-form-item label="铜管费:" :label-width="formLabelWidth" v-show="form.fee_gangguan!=='0.00'">
                    <div>{{form.fee_gangguan}}</div>
                </el-form-item>
                <el-form-item label="难度费:" :label-width="formLabelWidth" v-show="form.fee_nandu!=='0.00'">
                    <div>{{form.fee_nandu}}</div>
                </el-form-item>
                <el-form-item label="远程费:" :label-width="formLabelWidth" v-show="form.fee_yuancheng!=='0.00'">
                    <div>{{form.fee_yuancheng}}</div>
                </el-form-item>
                <el-form-item label="拆装机费:" :label-width="formLabelWidth" v-show="form.fee_chaizhuang!=='0.00'">
                    <div>{{form.fee_chaizhuang}}</div>
                </el-form-item>
                <el-form-item label="其他费用:" :label-width="formLabelWidth" v-show="form.fee_other!='0'&&typeof form.fee_other!=='object'">
                    <div>{{form.fee_other|formatter}}</div>
                </el-form-item>
            </el-form>
        </el-dialog>
    </div>
</template>
<script>
    import {getInstallList, getInstallCompany} from "../stores/api";

    export default {
        data () {
            return {
                dialogXiapai: false,
                FeiyongDetail: false,
                loading: false,
                page: 1,
                total: '',
                page_count: 1,
                tableData: [],
                selectCompany: [],
                isCompany: false, //搜索条件是否是安装公司
                ddlySelect: [{name: '全部', referer: ''}, {name: 'k3导入', referer: 'k3导入'}, {name: '新增', referer: '管理员添加'}, {name: 'PC商城', referer: 'PC'}, {name: '供应链', referer: '供应链'}, {name: '门店', referer: '门店'}, {name: '扫码', referer: '扫码'}],
                ddly: '',
                ssgnSelect: [{name: '合同订单号', referer: 'contract_number'}, {name: '客户电话', referer: 'mobile'}, {name: '安装公司', referer: 'company_name'}, {name: '型号', referer: 'goods_attr'}, {name: '业务员', referer: 'sale_name'}],
                ssgn: 'contract_number',
                searchKey: '',
                installDate: '', //安装日期搜索,
                form: {},
            }
        },
        created() {
            this.getInstallList()
            this.getInstallCompanyList()
        },
        filters:{

        },
        methods: {
            getInstallList() {
                this.loading = true
                let session_id = localStorage.getItem('shouhou_session_id')
                let temp = {}
                if (this.installDate !== '') {
                    temp.addtime1 = Date.parse(this.installDate[0].toLocaleDateString()).toString().slice(0, 10)
                    temp.addtime2 = Date.parse(this.installDate[1].toLocaleDateString()).toString().slice(0, 10)
                }
                temp.page = this.page
                temp.referer = this.ddly
                temp.status = '3'
                if (this.searchKey !== '') {
                    if (this.ssgn === 'contract_number') {
                        temp.contract_number = this.searchKey
                    } else if (this.ssgn === 'mobile') {
                        temp.mobile = this.searchKey
                    } else if (this.ssgn === 'company_name') {
                        temp.company_name = this.searchKey
                    } else if (this.ssgn === 'goods_attr') {
                        temp.goods_attr = this.searchKey
                    } else if (this.ssgn === 'sale_name') {
                        temp.sale_name = this.searchKey
                    }
                }
                getInstallList(temp).then(res => {
                    this.loading = false
                    // console.log(res.data.install_list)
                    this.tableData = res.data.install_list
                    this.total = res.data.count
                    if (res.data.install_list) {
                        this.tableData.forEach((item, i) => {
                            this.tableData[i]['addr'] = item.province + item.city + item.district + item.address
                        })
                    }
                })
            },
            //安装单导出
            Report () {
                let temp = {}
                if (this.installDate !== '') {
                    temp.addtime1 = Date.parse(this.installDate[0].toLocaleDateString()).toString().slice(0, 10)
                    temp.addtime2 = Date.parse(this.installDate[1].toLocaleDateString()).toString().slice(0, 10)
                }
                temp.referer = this.ddly
                temp.status = '3'
                if (this.searchKey !== '') {
                    if (this.ssgn === 'contract_number') {
                        temp.contract_number = this.searchKey
                    } else if (this.ssgn === 'mobile') {
                        temp.mobile = this.searchKey
                    } else if (this.ssgn === 'company_name') {
                        temp.company_name = this.searchKey
                    } else if (this.ssgn === 'goods_attr') {
                        temp.goods_attr = this.searchKey
                    } else if (this.ssgn === 'sale_name') {
                        temp.sale_name = this.searchKey
                    }
                }
                var str = ''
                for (var key in temp) {
                    str += '&' + key + '=' + temp[key]
                }
                window.open(this.$reqUrl + `service.php?act=install_done_excel&session_id=${localStorage.getItem('shouhou_session_id')}${str}`)
                // this.$http.get(this.$reqUrl + `service.php?act=install_excel&session_id=${localStorage.getItem('shouhou_session_id')}`).then(res => {
                //
                // })
            },
            //是否选择安装公司
            selectCompanys () {
                if (this.ssgn === 'company_name') {
                    this.isCompany = true
                    this.searchKey = this.selectCompany[0].company_name
                } else {
                    this.isCompany = false
                    this.searchKey = ''
                }
            },
            getInstallCompanyList () {
                getInstallCompany(this.page).then(res => {
                    this.selectCompany = []
                    this.selectCompany = res.data.company_list
                    this.page_count = res.data.page_count
                    if (this.page_count > 1) {
                        this.page = 2;
                        for (var i = 0; i < this.page_count - 1; i++) {
                            this.page += i;
                            getInstallCompany(this.page).then(res => {
                                res.data.company_list.forEach(item => {
                                    this.selectCompany.push(item)
                                })
                            })
                        }
                        // console.log(this.selectCompany)
                    }
                })
            },
            Details (row, price) {
                this.form = row
                this.tests = ''
                if (price === 0) {
                    this.tests = '无安装费用'
                }
                // console.log(row);
                this.FeiyongDetail = true
            },
            handleCurrentChange(val) {
                this.page = val
                this.getInstallList()
            },
        }
    }
</script>
<style lang="less" scoped>
    .wrapper{
        .bar {
            display: flex;
            justify-content: space-between;
            margin-bottom: 15px;
            .btnGroup {
                button {
                    width: 100Px;
                    height: 35Px;
                    margin-right: 10Px;
                    font-size: 16px;
                    color: #ffffff;
                    background: #f56c31;
                    border-radius: 2px;
                }
            }
        }
    }

</style>
<style>
    .el-table th>.cell{
        color:#ea6625;
    }
</style>



// WEBPACK FOOTER //
// src/router/InstallSingleReport.vue